import React from 'react';

interface ReviewLabelTextProps {
  children: React.ReactNode;
}

const ReviewLabelText = (props: ReviewLabelTextProps): JSX.Element => (
  <h6 className="all-caps faded u-display-inline-block">{props.children}</h6>
);

export default ReviewLabelText;
